import {useAppSelector} from "../../../redux/hooks";
import {
  getMySongsPageFilterFeatureValue
} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.selectors";
import {mySongsPageStore} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.store";
import {
  MySongsPageFilterLessonFeatureType
} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.types";

export interface IFilterFeatureVideoLessonLogic {
  value: MySongsPageFilterLessonFeatureType;
  onChangeHandler: (newValue: MySongsPageFilterLessonFeatureType) => void;
}

export const useFilterFeatureVideoLessonLogic = (): IFilterFeatureVideoLessonLogic => {
  const value = useAppSelector(getMySongsPageFilterFeatureValue);

  return {
    value,
    onChangeHandler: (featureLessonType: MySongsPageFilterLessonFeatureType) => mySongsPageStore.setFilterFeature(featureLessonType),
  };
}
